import React from 'react';

import ClusterSelect from 'app/components/cluster-select';

import useEventDebuggerClusterSelectProps from './useEventDebuggerClusterSelectProps';

export default function EventDebuggerClusterSelect() {
  const clusterSelectProps = useEventDebuggerClusterSelectProps();
  return <ClusterSelect {...clusterSelectProps} />;
}
